import { useState } from 'react';
import AlreadyFollow from '../follow-status-button/AlreadyFollow';
import NotRequestFollowYet from '../follow-status-button/NotRequestFollowYet';
import RequestedFollow from '../follow-status-button/RequestedFollow';
import { LoginModal } from '../../../modal/LoginModal';

interface IFollowSection {
  refectAfterChangeInformation: Function;
  isAccepted: boolean;
  uid: string;
  roleView: any;
}

const FollowSection = ({
  refectAfterChangeInformation,
  isAccepted,
  uid,
  roleView,
}: IFollowSection) => {
  const [loginModal, setLoginModal] = useState<boolean>(false);
  return (
    <>
      <div className="lg:flex lg:items-start">
        <AlreadyFollow
          refectAfterChangeInformation={refectAfterChangeInformation}
          roleView={roleView}
          isAccepted={isAccepted}
          uid={uid}
        />
      </div>
      <RequestedFollow
        roleView={roleView}
        refectAfterChangeInformation={refectAfterChangeInformation}
        uid={uid}
        isAccepted={isAccepted}
      />
      <NotRequestFollowYet
        roleView={roleView}
        setLoginModal={setLoginModal}
        refectAfterChangeInformation={refectAfterChangeInformation}
        uid={uid}
      />
      <LoginModal toggle={setLoginModal} isVisible={loginModal} />
    </>
  );
};

export default FollowSection;
